import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["menu", "button"];

  static values = { open: Boolean };

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    // Make this controller accessible globally for AJAX responses
    window.verifyDropdownController = this;
    // Set up global verification success handler
    this.setupVerificationHandler();
    // Set up form submission listener for disabling both buttons
    this.setupFormSubmissionListener();
    // Set up hover functionality for the dropdown button
    this.setupHoverEvents();
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.hasMenuTarget) {
      const isOpen = !this.menuTarget.classList.contains("hidden");

      if (isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  open() {
    if (this.hasMenuTarget) {
      // Clear any pending close timeout
      if (this.hoverCloseTimeout) {
        clearTimeout(this.hoverCloseTimeout);
        this.hoverCloseTimeout = null;
      }

      this.menuTarget.classList.remove("hidden");
      this.buttonTarget.setAttribute("aria-expanded", "true");
      document.addEventListener("click", this.closeOnClickOutside);

      // Add hover events to the menu to prevent it from closing when hovering over it
      if (!this.menuHoverEventsAdded) {
        this.menuTarget.addEventListener("mouseenter", () => {
          if (this.hoverCloseTimeout) {
            clearTimeout(this.hoverCloseTimeout);
            this.hoverCloseTimeout = null;
          }
        });

        this.menuTarget.addEventListener("mouseleave", () => {
          this.hoverCloseTimeout = setTimeout(() => {
            this.close();
          }, 200);
        });
        this.menuHoverEventsAdded = true;
      }
    }
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden");
      this.buttonTarget.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", this.closeOnClickOutside);
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  setupVerificationHandler() {
    // Set up global verification success handler
    window.handleVerificationSuccess = username => {
      this.handleVerificationSuccess(username);
    };
  }

  setupFormSubmissionListener() {
    // Listen for form submission on the main verify button
    const form = this.element.querySelector("form");

    if (form) {
      form.addEventListener("submit", () => {
        // Close dropdown immediately to prevent accidental misclicks
        this.close();

        // Disable the dropdown button when main button is submitted
        if (this.hasButtonTarget) {
          this.buttonTarget.disabled = true;
          this.buttonTarget.classList.add("opacity-50", "cursor-not-allowed");
        }
      });
    }
  }

  handleVerificationSuccess(username) {
    // Update review state
    $("[data-flow='review_state']").text("Verified");

    // Update verification info with current user and time
    const verificationHtml = `few seconds ago by ${username}`;

    // Find the verification section (contains "Verified:" text)
    const verificationSection = $('a.btn-flat:contains("Verified:")');

    verificationSection.find("span.text-sm").html(verificationHtml);

    // Flash light yellow highlight on verification info and review state area
    verificationSection.addClass("bg-yellow-50 transition-colors duration-300");

    // Also highlight the review state section (includes "Verified" text and history icon)
    const reviewStateSection = $("[data-flow='review_state']").closest(".flex.items-center");

    reviewStateSection.addClass("bg-yellow-50 transition-colors duration-300");

    setTimeout(() => {
      verificationSection.removeClass("bg-yellow-50");
      reviewStateSection.removeClass("bg-yellow-50");
    }, 2000);

    // Close the dropdown
    this.close();
  }

  setupHoverEvents() {
    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener("mouseenter", this.onMouseEnter);
      this.buttonTarget.addEventListener("mouseleave", this.onMouseLeave);
    }
  }

  onMouseEnter() {
    this.open();
  }

  onMouseLeave() {
    // Delay closing to allow user to move mouse to dropdown menu
    this.hoverCloseTimeout = setTimeout(() => {
      this.close();
    }, 200);
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside);

    // Clean up hover events
    if (this.hasButtonTarget) {
      this.buttonTarget.removeEventListener("mouseenter", this.onMouseEnter);
      this.buttonTarget.removeEventListener("mouseleave", this.onMouseLeave);
    }

    // Clear any pending timeout
    if (this.hoverCloseTimeout) {
      clearTimeout(this.hoverCloseTimeout);
    }

    // Clean up global reference
    if (window.verifyDropdownController === this) {
      window.verifyDropdownController = null;
      window.handleVerificationSuccess = null;
    }
  }
}
